import React, { useEffect, useState } from "react";
import { Form, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../assets/css/productcard.css'
import ProductReviews from "./ProductReviews";
import moment from 'moment';
import { Actions } from "../../Actions/Actions";
import { fetchAllNotifications } from "../../seller-apis/apidataField";


import { useAlert } from "react-alert";


//SL-698
import PriceComparisonTable from "../common/PriceComparisonTable";
import NewPriceOfferPopup from "./NewPriceOfferPopup";
import { inputValidations } from "../../Validations/Inputs";
import { useDispatch } from "react-redux";
import { verifyTransferPriceSingle, verifyTransferPriceCombination, newPriceReqSingle, newPriceReqCombination } from "../../Actions/ProductDetail/Single";
import { verifyTransferPriceSingle as verifyTransferPriceSingleComb, verifyTransferPriceCombination as verifyTransferPriceCombinationComb, newPriceReqSingle as newPriceReqSingleComb, newPriceReqCombination as newPriceReqCombinationComb } from "../../Actions/ProductDetail/Combination";
import api from "../../seller-apis/api";



function ProductCard(props) {

  const alert = useAlert();
  const dispatch = useDispatch();
  const [lowestPrice, setlowestPrice] = useState(undefined)
  const [sitetPrice, setSitePrice] = useState(undefined)
  const [selectedombinationIndex, setSelectedombinationIndex] = useState(0)


  //SL-699
  const [editableRow, setEditableRow] = useState(null); // Track which row is editable
  const [inputStockValue, setInputStockValue] = useState(0);

  // Product HSN
  const [editableRowHSN, setEditableRowHSN] = useState(null);
  const [inputHSNValue, setInputHSNValue] = useState('');

  // Sl-906
  const [curCombPrice, setCurCombPrice] = useState(null);
  const [currentCombinationIndex, setCurrentCombinationIndex] = useState(0);
  const [currentIsNewOffer, setCurrentIsNewOffer] = useState(false);
  const [currentIsNewWeightOffer, setCurrentIsNewWeightOffer] = useState(false);

  // New Price Offer Popup
  const [showPriceOfferPopup, setShowPriceOfferPopup] = useState(false);
  const [selectedOfferData, setSelectedOfferData] = useState(null);
  //SL-1067
  const [notificationData, setNotificationData] = useState({
    vpriceReqId: null,
    vendorId: null,
    combinationUrl: null,
    source: null
  });



  useEffect(() => {
    if (props.combination && props.combination.length > 0) {
      setlowestPrice(props.combination[0].lowestPrice < props.combination[0].price ? props.combination[0].lowestPrice : undefined)
      setSitePrice(props.combination[0].sitePrice);
    }
  }, [props.productName])

  // Reset indexes on every component mount/refresh
  useEffect(() => {
    if (props?.combination && props.combination.length > 0) {
      setCurrentCombinationIndex(0);
      setSelectedombinationIndex(0);

      const initialIsNewOffer = props.combination[0]?.prSts === "V_PENDING";
      const initialIsNewWeightOffer = props?.combination?.[0]?.sellerWeightChangeSts === "V_PENDING";
      setCurrentIsNewOffer(initialIsNewOffer);
      setCurrentIsNewWeightOffer(initialIsNewWeightOffer);
    }
  }, [props.lead, props?.combination])

  const reviewsArr = [1, 2, 3, 4, 5];


  function checkIsNewWeightOffer(combs) {
    for (let i = 0; i < combs.length; i++) {
      if (combs[i].sellerWeightChangeSts && combs[i].sellerWeightChangeSts === "V_PENDING") {
        return true
      }
    }
    return false
  }

  const checkIsWeightPending = (combs) => {
    for (let i = 0; i < combs.length; i++) {
      if (combs[i].sellerWeightChangeSts && combs[i].sellerWeightChangeSts === "T_PENDING") {
        return true
      }
    }
    return false
  }

  const isPriceEditingAllowed = () => {
    // Check if price verification is pending
    if (props.vendor?.prSts === "T_PENDING" || props.vendor?.prSts === "V_PENDING") {
      return false;
    }
    // check if sale is on vendor cannot edit price
    if (props.saleDiscount) {
      return false;
    }

    // For combination products, check the currently selected combination's verification status from vendor.combination
    if (props.combination && props.combination.length > 0 && props.vendor?.combination) {
      const selectedCombination = props?.combination?.[selectedombinationIndex];
      if (selectedCombination && (selectedCombination.prSts === "T_PENDING" || selectedCombination.prSts === "V_PENDING") || selectedCombination.saleDiscount === true) {
        return false;
      }
    }

    return true;
  };

  function changePrice(e) {
    console.log(props?.combination)

    let l = []
    let newl = [];
    l = e.value.split(",")
    let ele;
    const newIndex = parseInt(l[5]);

    setSelectedombinationIndex(newIndex);
    setCurrentCombinationIndex(newIndex);

    // Calculate isNewOffer for the new combination
    const newIsNewOffer = props?.combination && props?.combination[newIndex]?.prSts === "V_PENDING";
    setCurrentIsNewOffer(newIsNewOffer);

    // Calculate isNewWeightOffer for the new combination
    const newIsNewWeightOffer = props?.combination && props?.combination?.[newIndex]?.sellerWeightChangeSts === "V_PENDING";
    setCurrentIsNewWeightOffer(newIsNewWeightOffer);

    const priceElement = document.getElementById(`${l[0]}price`);
    const statusElement = document.getElementById(`${props.id}status`);
    const inventoryElement = document.getElementById(`${props.id}inventorystock`);
    if (priceElement) {
      priceElement.innerText = `${l[1]}`;
      console.log(l[1])
    }
    if (statusElement) {
      statusElement.innerText = `${l[3]}`;
    }
    if (localStorage.getItem("vendorType") === "In-House" && inventoryElement) {
      inventoryElement.innerText = `${l[4]}`;
    }
    setTimeout(() => {
      const ele = document.getElementById(`${props.id}td_status`);
      if (ele) {
        ele.className = "";
        if (l[3] === "In Stock") {
          ele.classList.add("invent_pro_status_active");
        } else {
          ele.classList.add("invent_pro_status_inactive");
        }
      }
    }, 0);

    newl = l.map(item => parseInt(item))

    if (newl[2] >= newl[1]) {
      setlowestPrice(undefined)
    }
    else {
      setlowestPrice(l[2])
    }
    //SL-699 Stock
    setInputStockValue(l[6]);


  }

  // Update response
  function getReviewCallback(res) {
    if (res === "product updated") {
      props.callbackGetProducts(res)
    }
  }

  //SL-699
  const styles = {
    container: {
      stock: {
        marginTop: "10px"
      }
    },
    text: {
      currentStock: {
        position: "absolute",
        top: "-7px",
        left: "18px",
        background: "white",
        padding: "0px 5px",
        fontSize: "11px",
        color: "black"
      }
    },
    icon: {
      wrapper: {
        position: "absolute",
        display: "inline-block",
        right: "13px",
        top: "7px",
        width: "20px", // Ensures consistent space for the icon
        height: "20px", // Ensures consistent space for the icon
      },
      editStock: {
        fontSize: "13px"
      },
      saveImg: {
        width: "14px",
        height: "14px"
      }
    },
    input: {
      stock: {
        padding: "7px 22px 6px 11px",
        width: "90px",
        // marginLeft: "10px",
        borderColor: "rgb(229 231 235)"
      }
    }
  }

  /**
   * SL - 699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if (/^\d*$/.test(stockValue))
      setInputStockValue(stockValue);

  };
  /**
   * Handle Edit Click
   * @param {*} id 
   */
  const handleStockEditClick = (id, stockValue) => {
    setEditableRow(id); // Set the editable row
    setInputStockValue(stockValue); // Reset to the original value when editing starts
  };
  /**
   * Handle Save Click
   */
  const handleStockSaveClick = () => {

    // Validation: Ensure the input is a positive number or zero
    if (isNaN(inputStockValue) || inputStockValue === '' || inputStockValue === null || inputStockValue === undefined) {
      alert.error("Please enter a valid number.");
      return;
    }
    const numericValue = Number(inputStockValue);
    if (numericValue < 0) {
      alert.error("Please enter a valid positive number.");
      return;
    }

    const url = props.combination !== undefined && props.combination !== null && props.combination.length > 0
      ? props.combination[selectedombinationIndex].url : null;
    props.updateSellerStock(editableRow, numericValue, url, props?.id, url ? props?.combination[selectedombinationIndex] : null);

    setEditableRow(null); // Save changes and make the input box non-editable
  };

  /**
   * Handle HSN Change
   * @param {*} hsnValue 
   */
  const handleHSNChange = (hsnValue) => {
    // Only allow numeric values for HSN codes (4-8 digits)
    if (/^\d*$/.test(hsnValue) && hsnValue.length <= 8)
      setInputHSNValue(hsnValue);
  };

  /**
   * Handle HSN Edit Click
   * @param {*} id 
   */
  const handleHSNEditClick = (id, hsnValue) => {
    setEditableRowHSN(id); // Set the editable row
    setInputHSNValue(hsnValue || ''); // Reset to the original value when editing starts
  };

  /**
   * Handle HSN Save Click
   */
  const handleHSNSaveClick = () => {
    // Use the validation function from Inputs.js
    const validation = inputValidations.hsn(inputHSNValue);

    if (!validation.status) {
      alert.error(validation.msg);
      return;
    }

    // Call the update function passed as prop
    if (props.updateProductHSN) {
      props.updateProductHSN(editableRowHSN, inputHSNValue.trim());
    } else {
      alert.success("HSN code updated successfully!");
    }

    setEditableRowHSN(null); // Save changes and make the input box non-editable
  };


  // Sl-906
  const handlePriceUpdate = () => {
    // Logic to handle price update
    const url = props.combination !== undefined && props.combination !== null && props.combination.length > 0
      ? props.combination[selectedombinationIndex].url : null;
    console.log(url, props.lead, props?.combination?.[selectedombinationIndex]?.price)
    if (props?.combination?.length > 0) {
      props?.handlePriceRequest({ isCombination: props?.combination?.length > 0 ? true : false, url: url, price: props?.combination?.[selectedombinationIndex]?.price, gst: props?.taxClass, lead: props.lead })
    }
    else {
      props?.handlePriceRequest({ isCombination: false, url: null, price: props?.price, gst: props?.taxClass, lead: props?.lead })
    }

  };

  // New Price Offer Popup Handlers
  const handlePriceOfferClick = (offerData) => {
    console.log('handlePriceOfferClick called with:', offerData);
    setSelectedOfferData(offerData);
    setShowPriceOfferPopup(true);
    console.log('Popup state set to true');
  };

  const checkShouldStockUpdate = async (stockValue, selectedComb) => {
    if (stockValue !== undefined && stockValue !== null && stockValue !== '') {
      try {
        let data;
        if (selectedComb) {
          let combData = {
            url: selectedComb?.url,
            stock: stockValue,
            vActive: Number(stockValue) > 0 ? 'ACTIVE' : 'INACTIVE'
          };
          data = {
            _id: props?.lead,
            combination: combData
          };
        }
        else {
          data = {
            _id: props?.lead,
            stock: stockValue
          }
        }
        await props.updateSellerStock(props?.lead, stockValue, selectedComb?.url, props?.id, selectedComb?.url ? selectedComb : null,true);
      }
      catch (err) {
        console.log('Error updating stock after price offer acceptance:', err);
      }
    }
  }


  const handlePriceOfferYes = async(selectedComb, stockValue) => {
    if (selectedOfferData.combinations && selectedOfferData.combinations.length > 0) {
      const data = {
        product: selectedOfferData.productId,
        _id: selectedComb?.vPriceReqId,
        status: "V_ACTIVE",
        price: selectedComb?.n_purchase_price,
        url: selectedComb?.url
      };

      api.transferprice.updatePriceRequest(data).then((res) => {
        if (res.message === "price change request submitted" || res.message === "price request updated") {
          alert.success('Price offer accepted successfully!');
          checkShouldStockUpdate(stockValue, selectedComb)
          let combData = {
            url: selectedComb?.url,
            stock: stockValue
          }
          // Remove the accepted combination from selectedOfferData
          if (selectedOfferData.combinations && selectedOfferData.combinations.length > 0) {
            const originalCount = selectedOfferData.combinations.length;
            const remainingCombinations = selectedOfferData.combinations.filter(comb =>
              comb.url !== selectedComb?.url
            );
            const remainingCount = remainingCombinations.length;


            if (remainingCombinations.length > 0) {
              setSelectedOfferData(prev => ({
                ...prev,
                combinations: remainingCombinations
              }));

            } else {
              console.log('All combinations processed, closing popup');
              refreshProducts();
            }
          } else {
            refreshProducts();
          }
        } else {
          alert.info(res.message);
        }
      }).catch((err) => {
        alert.error('Error accepting price offer');
      });
    } else {
      const data = {
        product: selectedOfferData.productId,
        _id: selectedOfferData?.vendor?.vPriceReqId,
        status: "V_ACTIVE",
        price: selectedOfferData.newPrice
      };


      api.transferprice.updatePriceRequest(data).then(async (res) => {
        console.log('Single product price offer acceptance API response:', res);
        if (res.message === "price change request submitted" || res.message === "price request updated") {
          alert.success('Price offer accepted successfully!');
          checkShouldStockUpdate(stockValue, undefined)
          setShowPriceOfferPopup(false)
          refreshProducts();
          await closeNotificationAndRefresh('price');
        } else {
          alert.info(res.message);
        }
      }).catch((err) => {
        console.log('Single product price offer acceptance error:', err);
        alert.error('Error accepting price offer');
      });
    }

    // setShowPriceOfferPopup(false);
  };

  const handlePriceOfferNo = () => {

  };

  const handleNewPriceSubmit = async (newPrice, stockValue, combination) => {

    const data = {
      product: selectedOfferData?.productId,
      price: newPrice
    };

    if (combination && combination?.url) {
      data.url = combination?.url;
    }

    api.transferprice.priceChangeRquest(data).then(async(res) => {
      if (res.message === "price change request submitted" || res.message === "price request updated") {
        alert.success('New price request successfully sent to Toolsvilla');
         await closeNotificationAndRefresh('price');
        checkShouldStockUpdate(stockValue, combination)

        // Remove the rejected combination from selectedOfferData
        if (selectedOfferData.combinations && selectedOfferData.combinations.length > 0) {
          const originalCount = selectedOfferData.combinations.length;
          const rejectedUrl = combination?.url;
          const remainingCombinations = selectedOfferData.combinations.filter(comb =>
            comb.url !== rejectedUrl
          );
          const remainingCount = remainingCombinations.length;

          if (remainingCombinations.length > 0) {
            setSelectedOfferData(prev => ({
              ...prev,
              combinations: remainingCombinations
            }));
          } else {
            refreshProducts()

          }
        } else {
          console.log('Single product processed, closing popup');
          refreshProducts()
        }
      } else {
        alert.info(res.message);
      }
    }).catch((err) => {
      console.log('API error:', err);
      alert.error('Error submitting new price request');
    });
  };
  
  const closeNotificationAndRefresh = async (notificationType) => {
    try {
      const vendorId = localStorage.getItem('vendorId');
      const selectedId = props.lead; // ✅ Use props.lead as the product ID
      const comburl = props.combination && props.combination.length > 0 
        ? props.combination[selectedombinationIndex]?.url 
        : null; // ✅ Get combination URL if exists
      
      if (notificationType === 'price') {
        // Close price notification
        await api.notify.closeVendorPriceNotification({
          productId: String(selectedId),
          vendorId: String(vendorId),
          combinationUrl: comburl || notificationData.combinationUrl,
          source: notificationData.source || 'notification',
          vpriceReqId: notificationData.vpriceReqId ? String(notificationData.vpriceReqId) : undefined,
        });
      } else if (notificationType === 'weight') {
        // Close weight notification  
        await api.notify.closeVendorWeightNotification(
          String(selectedId),
          String(vendorId)
        );
      }
  
      // ✅ Update vendor activity log to refresh bell icon count
      await api.notify.updateVendorActLogs({
        filter: {
          "product-objectId": selectedId
        }
      });
  
      // ✅ Fetch latest notification count and update Redux
      // const dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
      // const dateToWeb = moment().format('YYYY-MM-DD');
      
      // const countData = {
      //   pageNo: 1,
      //   size: 1,
      //   filters: {
      //     type: { $in: ["PRC_CHANGED"] },
      //     opened: false,
      //     "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
      //     "to-createdAt": dateToWeb + 'T23:59:59.000Z'
      //   },
      // };
      
      // const res = await api.notify.fetchNotifications(fetchAllNotifications(countData));
      
      // // ✅ Update Redux with new count (this updates the bell icon)
      // Actions.updateNotificationCount(dispatch, res.totalRecords);
  
    } catch (error) {
      console.error('Error closing notification:', error);
      // Don't show error to user, fail silently
    }
  };

  // Function to refresh products after price changes
  const refreshProducts = () => {
    setSelectedombinationIndex(0)
    setCurrentCombinationIndex(0);
    // Check for callbackGetProducts first (most common in ActiveProducts)
    if (props.callbackGetProducts && typeof props.callbackGetProducts === 'function') {
      props.callbackGetProducts("product updated");
    } else if (props.getProducts && typeof props.getProducts === 'function') {
      props.getProducts();
    } else if (props.refreshProducts && typeof props.refreshProducts === 'function') {
      props.refreshProducts();
    }
  };

  // Helper function to render Stock section
  const renderStockSection = () => {
    // Check if stock exists and is not empty, null, or undefined (0 is valid)
    const stockValue = props.combination && props.combination.length > 0
      ? props.combination[selectedombinationIndex].stock
      : props.quantity;
    const hasValidStock = stockValue !== undefined && stockValue !== null && stockValue !== '' && stockValue >= 0;

    if (hasValidStock) {
      // If stock exists, show only number and edit option (no label, no box)
      // But if currently editing, show the input box
      if (editableRow === props.lead) {
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <input
                type="number"
                value={editableRow === props.lead ? inputStockValue : stockValue}
                onChange={(e) => {
                  if (editableRow === props.lead) {
                    handleStockChange(e.target.value);
                  }
                }}
                disabled={editableRow !== props.lead}
                style={styles.input.stock}
                onWheel={(e) => e.target.blur()}
              />
              <div style={styles.icon.wrapper}>
                <img
                  src='/save.png'
                  style={styles.icon.saveImg}
                  onClick={handleStockSaveClick}
                />
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                <span style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: stockValue === 0 ? "red" : "#000",
                  minWidth: 'auto',
                  width: 'auto',
                  padding: '0',
                  backgroundColor: 'transparent',
                  border: 'none'
                }}>
                  {stockValue}
                </span>
                <i
                  className="bi bi-pencil"
                  style={{
                    ...styles.icon.editStock,
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: '#168A86'
                  }}
                  onClick={() => handleStockEditClick(props.lead, stockValue)}
                ></i>
              </div>
            </div>
          </div>
        );
      }
    } else {
      // If stock doesn't exist, show "+ Add Stock" button or input box if editing
      if (editableRow === props.lead) {
        // Show input box when editing
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <input
                type="number"
                value={inputStockValue}
                onChange={(e) => {
                  if (editableRow === props.lead) {
                    handleStockChange(e.target.value);
                  }
                }}
                disabled={editableRow !== props.lead}
                style={styles.input.stock}
                onWheel={(e) => e.target.blur()}
                placeholder="Enter stock quantity"
              />
              <div style={styles.icon.wrapper}>

                <img
                  src='/save.png'
                  style={styles.icon.saveImg}
                  onClick={handleStockSaveClick}
                />
              </div>
            </div>
          </div>
        );
      } else {
        // Show "+ Add Stock" button when not editing
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <button
                onClick={() => handleStockEditClick(props.lead, '')}
                style={{
                  background: 'transparent',
                  border: '1px dashed #168A86',
                  borderRadius: '4px',
                  padding: '4px 8px',
                  color: '#168A86',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px'
                }}
              >
                <i className="bi bi-plus" style={{ fontSize: '12px' }}></i>
                Add Stock
              </button>
            </div>
          </div>
        );
      }
    }
  };

  // Helper function to render HSN section
  const renderHSNSection = () => {
    // Check if HSN exists and is not empty, null, undefined, or just whitespace
    const hsnValue = String(props.hsn || '').trim();
    const hasValidHSN = hsnValue !== '' && hsnValue !== 'null' && hsnValue !== 'undefined';

    if (hasValidHSN) {
      // If HSN exists, show only number and edit option (no label, no box)
      // But if currently editing, show the input box
      if (editableRowHSN === props.lead) {
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <input
                type="number"
                value={inputHSNValue}
                onChange={(e) => {
                  if (editableRowHSN === props.lead) {
                    handleHSNChange(e.target.value);
                  }
                }}
                disabled={editableRowHSN !== props.lead}
                style={styles.input.stock}
                onWheel={(e) => e.target.blur()}
                min="1000"
                max="99999999"
                step="1"
              />
              <div style={styles.icon.wrapper}>
                <img
                  src='/save.png'
                  style={styles.icon.saveImg}
                  onClick={handleHSNSaveClick}
                />
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#000'
                }}>
                  {hsnValue}
                </span>
                <i
                  className="bi bi-pencil"
                  style={{
                    ...styles.icon.editStock,
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: '#168A86'
                  }}
                  onClick={() => handleHSNEditClick(props.lead, hsnValue)}
                ></i>
              </div>
            </div>
          </div>
        );
      }
    } else {
      // If HSN doesn't exist, show "+ Add HSN" button or input box if editing
      if (editableRowHSN === props.lead) {
        // Show input box when editing
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <input
                type="number"
                value={inputHSNValue}
                onChange={(e) => {
                  if (editableRowHSN === props.lead) {
                    handleHSNChange(e.target.value);
                  }
                }}
                disabled={editableRowHSN !== props.lead}
                style={styles.input.stock}
                onWheel={(e) => e.target.blur()}
                min="1000"
                max="99999999"
                step="1"
                placeholder="Enter HSN code"
              />
              <div style={styles.icon.wrapper}>
                <img
                  src='/save.png'
                  style={styles.icon.saveImg}
                  onClick={handleHSNSaveClick}
                />
              </div>
            </div>
          </div>
        );
      } else {
        // Show "+ Add HSN" button when not editing
        return (
          <div className="row" style={styles.container.stock}>
            <div className="col-12">
              <button
                onClick={() => handleHSNEditClick(props.lead, '')}
                style={{
                  background: 'transparent',
                  border: '1px dashed #168A86',
                  borderRadius: '4px',
                  padding: '4px 8px',
                  color: '#168A86',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px'
                }}
              >
                <i className="bi bi-plus" style={{ fontSize: '12px' }}></i>
                Add HSN
              </button>
            </div>
          </div>
        );
      }
    }
  };

  if (props.status === "PENDING") {
    let d = new Date();
    d = d.toDateString()
    let m = d.substr(4);
    var isNew = false;
    if (m === props.updatedon) {
      isNew = true;
    }
    if (props.combination && props.combination.length > 0) {


      return (
        <>
          <tr className='space color-row5 ord_table_row'>
            <td><div className='border-x'> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" /></div></td>
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='border-x inline-initial'><a href="#popupDetail" className='prod-name' onClick={() => props.detail(props.id)}> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                <p className='order_table_sku'>SKU:- {props.SKU}  {props.showButton && <a href={`/productDetail/${props.lead}/approv`} target="_blank" class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a>}</p>
                <div className="order_table_sku">Combination requested :
                  <mark>
                    {props.combination.length > 0 && props.combination.map((item, index) => {
                      return (
                        <span className="fs-11 fw-bold tools_168a86" key={index} value={`${props.id},${item.price}`}> {item.com}</span>
                      )
                    })}
                  </mark>
                </div>

              </div>
            </td>
            <td>
              <div className='border-x'>
                <div className='prod-price'>{props.price && <i class="fa fa-inr" aria-hidden="true"></i>} {parseInt(props.price)} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}</div>
                {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                  <div className='prod-card-gst'>(incl. <strong>{props.taxClass}%</strong> GST)</div>
                )}

              </div>
            </td>
            <td><div className='border-x'>{props.updatedon}</div></td>
            <td><div className='border-x'>Pending for approval</div></td>
          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
            closeNotificationAndRefresh={closeNotificationAndRefresh}
          />
        </>
      )
    }


    else {
      return (
        <>
          <tr className='space color-row5 ord_table_row'>
            <td><div className='border-x'> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" /></div></td>
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='border-x inline-initial'> <a href="#popupDetail" className='prod-name' onClick={() => props.detail(props.id)}> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                <p className='order_table_sku'>SKU:- {props.SKU}</p>
              </div>
            </td>
            <td><div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price)} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}</div>
              {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                <div className='prod-card-gst'>(incl. <strong>{props.taxClass}%</strong> GST)</div>
              )}

            </div>
            </td>
            <td><div className='border-x'>{props.updatedon}</div></td>
            <td><div className='border-x'>Pending for approval</div></td>
          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
          />
        </>
      )
    }

  }
  else if (props.combination && props.combination.length > 0) {

    let allVendrCombs = [];
    let combinationKeys = [];
    let isNewOffer;
    let isNewWeightOffer;
    let isWeightPending;

    allVendrCombs = props?.combination;

    isNewOffer = currentIsNewOffer;
    isNewWeightOffer = checkIsNewWeightOffer(allVendrCombs);
    isWeightPending = checkIsWeightPending(allVendrCombs);

    if (props.status === "INACTIVE") {
      return (
        <>
          <tr className=' space color-row5 ord_table_row'>
            {/* <td className="td-img-cntn"></td> */}
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='invent_table_first_col'>
                <div><img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" />
                </div>
                <div className='inline-initial'> <a className='prod-name' href={`/productDetConf/${props.lead}?url=${props.combination[0].url}`} target="_blank"> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                  <p className='order_table_sku'>SKU:- {props.SKU}                   {props.showButton && <a href={`/productDetail/${props.lead}/approv`} target="_blank" class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a>}</p>
                  <p className="invent_table_sku my-2">Combination's added : <Form.Select size="sm" className="pro_card_comb_box_invent" value={`${props.id},${props.combination[selectedombinationIndex]?.price},${props.combination[selectedombinationIndex]?.lowestPrice},${props.combination[selectedombinationIndex]?.status},${props.combination[selectedombinationIndex]?.inventoryStock},${selectedombinationIndex},${props.combination[selectedombinationIndex]?.stock}`} onChange={(e) => changePrice(e.target)}>
                    {props.combination.length > 0 && props.combination.map((item, index) => {
                      return (
                        <option key={index} value={`${props.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock},${index},${item.stock}`}>{item.com}</option>
                      )
                    })}
                  </Form.Select></p>

                  {/* Verification Pending Messages for Combination Products */}
                  {props?.combination && props?.combination[currentCombinationIndex]?.prSts === "T_PENDING" ? (
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch me-2"></i>
                      Price approval pending from Toolsvilla
                    </div>
                  ) : <></>}

                  {props.showPriceMsg && props?.offerForArr?.length > 0 ? <>
                    <div
                      className="pc_tp_new"
                      style={{ cursor: 'pointer', display: 'block' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        handlePriceOfferClick({
                          productId: props.lead,
                          productName: props.productName,
                          currentPrice: 'N/A',
                          newPrice: 'N/A',
                          taxClass: props.taxClass,
                          combinations: props.offerForArr,
                          vendor: props.vendor,
                          stock: props?.quantity
                        });
                      }}
                    >
                      <i className="bi bi-info-circle me-2"></i>
                      New transfer Price Offer from Toolsvilla
                    </div></> : <></>}
                  {/* {isNewWeightOffer ? <p className="pc_tp_wd"><i className="bi bi-info-circle me-2"></i> New weight and dimension from toolsvilla</p> : <></>} */}
                  {isWeightPending ? (
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch me-2"></i>
                      Weight Verification Pending
                    </div>
                  ) : <></>}
                </div>
              </div>
            </td>

            <td id={`${props.id}td_status`} className={`${props.combination[0].status === ("In Stock" || "Out of Stock") ? "invent_pro_status_active" : "invent_pro_status_inactive"}`}>
              <div className='border-x'>
                {/* {props.combination && <span id={`${props.id}status`}>{props.combination[0] && props.combination[0].status ? props.combination[0].status : undefined}</span>} */}
                {/*SL-699 Seller Stock Feature Updates Start For Attribute*/}
                {renderStockSection()}
                {/* <span id={`${props.id}inventorystock`}>{localStorage.getItem("vendorType") === "In-House" ? props.combination ? props.combination[0].inventoryStock : undefined : <></>}</span> */}
              </div>
            </td>
            <td>
              <div className='border-x'>
                {renderHSNSection()}
              </div>
            </td>
            <td>
              <div className='border-x'>
                <div className={props?.combination[selectedombinationIndex]?.saleDiscount ? 'prod-price sale-offer-box': 'prod-price'}>{props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price && <i class="fa fa-inr" aria-hidden="true"></i>} {props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price ? parseInt(props.combination[selectedombinationIndex].price) : undefined}  {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                  <>
                    <span className='prod-card-gst'>(incl. {props.taxClass}% GST)</span>
                    {props.combination[selectedombinationIndex].saleDiscount && 
                    <span className="sale-offer-text">Special Sale Transfer Price</span>}
                  </>
                )} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}</div>

                {/*<div className='prod-card-gst'>
               {!props?.recommendedPrice && props.lowestPrice && props.lowestPrice < props.price ? <span className="text-danger">Other seller's price: Rs.{props.lowestPrice}</span> : <></>}</div> */}
                {/* {props?.tabType=="activeProducts" &&(() => {
                  // Get the selected combination
                  const selectedCombination = props?.combination[selectedombinationIndex];

                  // Check if recommendedTransferPrice exists and is lower than the regular price
                  const recommendedTransferPrice = selectedCombination?.recommendedTransferPrice;
                  const combinationPrice = selectedCombination?.price;

                  // Determine the lowest price between recommendedTransferPrice and props.lowestPrice
                  let lowestPrice = null;

                  if (recommendedTransferPrice && props.lowestPrice) {
                    // Compare the recommendedTransferPrice and props.lowestPrice, and choose the smaller value
                    lowestPrice = props.lowestPrice < recommendedTransferPrice ? props.lowestPrice : recommendedTransferPrice;
                  } else if (recommendedTransferPrice) {
                    lowestPrice = recommendedTransferPrice;
                  } else if (props.lowestPrice) {
                    lowestPrice = props.lowestPrice;
                  }

                  // If the lowest price exists, show it as the suggested price
                  return lowestPrice ? (
                    <>
                      <div className='prod-price suggest-price'>
                        <img src="/rise.png" alt="rise" />
                        <i className="fa fa-inr" aria-hidden="true"></i> {lowestPrice} 
                        <span> (Suggested Price)</span>
                      </div>
                      {recommendedTransferPrice < combinationPrice && (
                        <>
                          <div className="comp-msg">
                            <img src="/warning-triangle.png" alt="warning" />
                            Losing order to competitors due to high prices
                          </div>
                          <div
                            onClick={() =>
                              props.getPriceMatchObject({
                                otherPrice: 20,
                                SKU: props.SKU,
                                productId: props.lead,
                                lowestPrice: lowestPrice,
                                url: selectedCombination?.url,
                              })
                            }
                            className="add_pro_form_fin_btns btnWriteRev btnWriteRevProdList"
                          >
                            <button> Accept</button>
                          </div>
                        </>
                      )}
                    </>
                  ) : null;
                })()} */}
                {props.showPriceMsg && isNewOffer ? <>
                  <div
                    className="pc_tp_new"
                    style={{ cursor: 'pointer', display: 'block' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      handlePriceOfferClick({
                        productId: props.lead,
                        productName: props.productName,
                        currentPrice: 'N/A',
                        newPrice: 'N/A',
                        taxClass: props.taxClass,
                        combinations: props.offerForArr,
                        vendor: props.vendor,
                        stock: props?.quantity
                      });
                    }}
                  >
                    New transfer Price Offer from Toolsvilla
                  </div></> : <></>}
              </div>
            </td>
            {props.curURL == 'active' && <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {sitetPrice}</span>

              <br></br>
              <span className="fs-11 text-success">TV Commission Rs. {sitetPrice - (props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price ? props.combination[selectedombinationIndex].price : 0)}<br />{props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && `(incl. ${props.taxClass}% GST)`}</span></td>}

            <td>
              <div className='border-x'>

                {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ? <p className="pro_card_price_ver_pend">Price approval pending from Toolsvilla</p> : <></>}
                <div>
                  {!props.vendor.prSts ? <button className="invent_pro_v_t_f_btn" onClick={() => window.open(`/productDetConf/${props.lead}?url=${props.combination[0].url}`, "_blank")}> Verify Transfer Price</button> :

                    <></>
                  }
                  <button className={`mt-1 ${lowestPrice != undefined ? "invent_pro_modify_red" : "invent_pro_modify"}`} onClick={() => window.open(`/productDetConf/${props.lead}?url=${props.combination[0].url}`, "_blank")}><img src={`/${lowestPrice != undefined ? "edit-icon-white" : "edit-icon"}.webp`} /> Modify</button>
                </div>
              </div>

            </td>

          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
          />
        </>
      )
    }
    else {
      return (
        <>
          <tr className=' space color-row5 ord_table_row'>
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='invent_table_first_col'>
                <div><img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" />
                </div>
                <div className=' inline-initial'> <a className='prod-name' href={`/productDetConf/${props.lead}?url=${props.combination[0].url}`} target="_blank"> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                  <p className='order_table_sku'>SKU:- {props.SKU}                   {props.showButton && <a href={`/productDetail/${props.lead}/approv`} target="_blank" class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a>}</p>
                  <p className="invent_table_sku my-2">Combination's added : <Form.Select size="sm" className="pro_card_comb_box_invent" value={`${props.id},${props.combination[selectedombinationIndex]?.price},${props.combination[selectedombinationIndex]?.lowestPrice},${props.combination[selectedombinationIndex]?.status},${props.combination[selectedombinationIndex]?.inventoryStock},${selectedombinationIndex},${props.combination[selectedombinationIndex]?.stock}`} onChange={(e) => changePrice(e.target)}>
                    {props.combination.length > 0 && props.combination.map((item, index) => {
                      return (
                        <option key={index} value={`${props.id},${item.price},${item.lowestPrice},${item.status},${item.inventoryStock},${index},${item.stock}`}>{item.com}</option>
                      )
                    })}
                  </Form.Select></p>

                  {/* Verification Pending Messages for Combination Products */}
                  {props?.combination && props?.combination[currentCombinationIndex]?.prSts === "T_PENDING" ? (
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch me-2"></i>
                      Price approval pending from Toolsvilla
                    </div>
                  ) : <></>}

                  {props.showPriceMsg && props?.offerForArr?.length > 0 ? <><div
                    className="pc_tp_new"
                    style={{ cursor: 'pointer', display: 'block' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      // Get the new price from n_purchase_price (inside vendor.combination for combination products)
                      const newPrice = props?.combination && props?.combination.length > 0
                        ? props?.combination?.[selectedombinationIndex]?.n_purchase_price
                        : props?.n_purchase_price;

                      const currentPrice = props?.combination && props?.combination.length > 0
                        ? props?.combination?.[selectedombinationIndex]?.purchase_price
                        : props.price;

                      handlePriceOfferClick({
                        productId: props.lead,
                        productName: props.productName,
                        currentPrice: currentPrice,
                        newPrice: newPrice,
                        taxClass: props.taxClass,
                        combinations: props.offerForArr,
                        vendor: props.vendor,
                        stock: props?.quantity
                      });
                    }}
                  >
                    <i className="bi bi-info-circle me-2"></i>
                    New transfer Price Offer from Toolsvilla
                  </div></> : <></>}
                  {/* {isNewWeightOffer ? <p className="pc_tp_wd"><i className="bi bi-info-circle me-2"></i> New weight and dimension from toolsvilla</p> : <></>} */}
                  {isWeightPending ? (
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch me-2"></i>
                      Weight Verification Pending
                    </div>
                  ) : <></>}
                </div>
              </div>
            </td>


            <td id={`${props.id}td_status`} className={`${props.combination[selectedombinationIndex].status === ("In Stock" || "Out of Stock") ? "invent_pro_status_active" : "invent_pro_status_inactive"}`} >
              <div className='border-x'>
                {/* {props.combination && props.combination[selectedombinationIndex].status && <span id={`${props.id}status`}>{props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].status ? props.combination[selectedombinationIndex].status : undefined}</span>} */}
                {/* <span id={`${props.id}inventorystock`}>{localStorage.getItem("vendorType") === "In-House" ? props.combination ? props.combination[0].inventoryStock : undefined : <></>}</span> */}
                {
                  props.status === "INACTIVE_REQ" ?
                    <OverlayTrigger
                      key={props.id}
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                          <p className="fs-10 f-500 payment_page_tooltip_1">  Out of stock request pending for approval</p>

                        </Tooltip>
                      }
                    >
                      <i class="bi bi-exclamation-circle ms-1 text-danger"></i>
                      <br /><br />
                    </OverlayTrigger>

                    : <></>
                }

                {/*SL-699 Seller Stock Feature Updates Start For Attribute*/}
                {renderStockSection()}

                {/*<label
                    style={{
                      fontSize: "11px",
                      color: editableRow !== props.lead ? "#a9a9a9" : "black", // Grey out label when input is disabled
                      marginBottom: "4px",
                      fontWeight: '400'
                    }}
                  >
                    Current Stock
                </label>
                <div style={{ display: "flex",alignItems: "center" }}>
                
                  <input
                      type="number"
                      value={
                        editableRow === props.lead 
                        ? inputStockValue !== undefined && inputStockValue !== null
                         ? inputStockValue 
                         : '' 
                        : props.combination[selectedombinationIndex].stock !== undefined &&
                          props.combination[selectedombinationIndex].stock !== null
                          ? props.combination[selectedombinationIndex].stock 
                          : ''
                      }
                      onChange={(e) => {
                        if (editableRow === props.lead) {
                          handleStockChange(e.target.value);
                        }
                      }}
                      disabled={editableRow !== props.lead} // Disable input unless it's editable
                      style={{
                        borderRadius: "3px",
                        width: "65px",
                        textAlign: "center",
                        backgroundColor: editableRow !== props.lead ? "#f0f0f0" : "white", // Greyed out background
                        color: editableRow !== props.lead ? "#a9a9a9" : "black", // Greyed out text
                        cursor: editableRow !== props.lead ? "not-allowed" : "text", // Not-allowed cursor for disabled state
                        marginBottom: "4px"
                      }}
                    />
                    
                    {editableRow === props.lead ? (
                      <img 
                        src={'/save.png'} 
                        style={{marginBottom: '5px', marginLeft: '5px', cursor: "pointer"}} 
                        onClick={handleStockSaveClick}
                      />
                    ) : (
                      <img 
                        src={'/edit-grey.png'} 
                        style={{marginBottom: '5px', marginLeft: '5px', cursor: "pointer"}} 
                        onClick={() => handleStockEditClick(props.lead,
                          props.combination[selectedombinationIndex].stock !== undefined &&
                          props.combination[selectedombinationIndex].stock !== null
                          ? props.combination[selectedombinationIndex].stock 
                          : '')}
                      />
                    )}
                </div>*/}
                {/*SL-699 Seller Stock Feature Updates End For Attribute */}
              </div>
            </td>
            <td>
              <div className='border-x'>
                {renderHSNSection()}
              </div>
            </td>
            {props.curURL == 'active' && <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {sitetPrice}</span>

              <br></br>
              <span className="fs-11 text-success">TV Commission Rs. {sitetPrice - (props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price ? props.combination[selectedombinationIndex].price : 0)}<br />{props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && `(incl. ${props.taxClass}% GST)`}</span></td>}
            <td>
              <div className='border-x'>
                <div className={props?.combination[selectedombinationIndex]?.saleDiscount ? 'prod-price sale-offer-box': 'prod-price'}> {props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price && <i class="fa fa-inr" aria-hidden="true"></i>} {props.combination[selectedombinationIndex] && props.combination[selectedombinationIndex].price ? parseInt(props.combination[selectedombinationIndex].price) : undefined}  {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                  <>
                  <span className='prod-card-gst'>(incl. {props.taxClass}% GST)</span>
                    {props.combination[selectedombinationIndex].saleDiscount && 
                  <span className="sale-offer-text">Special Sale Transfer Price</span>}
                  </>
                )} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}</div>

                {/* <div className='prod-card-gst'>
              {!props?.recommendedPrice && props.lowestPrice && props.lowestPrice < props.price ? <span className="text-danger">Other seller's price: Rs.{props.lowestPrice}</span> : <></>}</div> */}
                {/* {props?.tabType=="activeProducts" &&(() => {
                  // Get the selected combination
                  const selectedCombination = props?.combination[selectedombinationIndex];

                  // Check if recommendedTransferPrice exists and is lower than the regular price
                  const recommendedTransferPrice = selectedCombination?.recommendedTransferPrice;
                  const combinationPrice = selectedCombination?.price;

                  // Determine the lowest price between recommendedTransferPrice and props.lowestPrice
                  let lowestPrice = null;

                  if (recommendedTransferPrice && props.lowestPrice) {
                    // Compare the recommendedTransferPrice and props.lowestPrice, and choose the smaller value
                    lowestPrice = props.lowestPrice < recommendedTransferPrice ? props.lowestPrice : recommendedTransferPrice;
                  } else if (recommendedTransferPrice) {
                    lowestPrice = recommendedTransferPrice;
                  } else if (props.lowestPrice) {
                    lowestPrice = props.lowestPrice;
                  }

                  // If the lowest price exists, show it as the suggested price
                  return lowestPrice ? (
                    <>
                      <div className='prod-price suggest-price'>
                        <img src="/rise.png" alt="rise" />
                        <i className="fa fa-inr" aria-hidden="true"></i> {lowestPrice} 
                        <span> (Suggested Price)</span>
                      </div>
                      {recommendedTransferPrice < combinationPrice && (
                        <>
                          <div className="comp-msg">
                            <img src="/warning-triangle.png" alt="warning" />
                            Losing order to competitors due to high prices
                          </div>
                          <div
                            onClick={() =>
                              props.getPriceMatchObject({
                                otherPrice: 20,
                                SKU: props.SKU,
                                productId: props.lead,
                                lowestPrice: lowestPrice,
                                url: selectedCombination?.url,
                              })
                            }
                            className="add_pro_form_fin_btns btnWriteRev btnWriteRevProdList"
                          >
                            <button> Accept</button>
                          </div>
                        </>
                      )}
                    </>
                  ) : null;
                })()} */}
                {props.showPriceMsg && isNewOffer ? <><div
                  className="pc_tp_new"
                  style={{ cursor: 'pointer', display: 'block' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    // Get the new price from n_purchase_price (inside vendor.combination for combination products)
                    const newPrice = props.combination && props.combination.length > 0
                      ? props.vendor?.combination?.[selectedombinationIndex]?.n_purchase_price
                      : props.vendor?.n_purchase_price;

                    const currentPrice = props.combination && props.combination.length > 0
                      ? props.vendor?.combination?.[selectedombinationIndex]?.purchase_price
                      : props.price;

                    handlePriceOfferClick({
                      productId: props.lead,
                      productName: props.productName,
                      currentPrice: currentPrice,
                      newPrice: newPrice,
                      taxClass: props.taxClass,
                      combinations: props.offerForArr,
                      vendor: props.vendor,
                      stock: props?.quantity
                    });
                  }}
                >
                  New transfer Price Offer from Toolsvilla
                </div></> : <></>}

              </div>
            </td>

            <td>
              <div className='border-x'>

                {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ? <>
                  <p className="pro_card_price_ver_pend">Price approval pending from Toolsvilla</p>
                  <br></br>
                </>
                  : <></>}
                <div>
                  {!props.vendor.prSts ? <button className="invent_pro_v_t_f_btn" onClick={() => window.open(`/productDetConf/${props.lead}?url=${props.combination[0].url}`, "_blank")}> Verify Transfer Price</button> :

                    <></>
                  }
                  <br />
                  <button className={`mt-1 ${lowestPrice != undefined ? "invent_pro_modify_red" : "invent_pro_modify"}`} onClick={() => window.open(`/productDetConf/${props.lead}?url=${props.combination[0].url}`, "_blank")}><img src={`/${lowestPrice != undefined ? "edit-icon-white" : "edit-icon"}.webp`} /> Modify</button>
                </div>
              </div>
            </td>

          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
          />
        </>
      )
    }
  }
  else {
    if (props.status === "INACTIVE") {
      return (
        <>
          <tr className='space color-row5 ord_table_row'>
            {/* <td className="td-img-cntn"></td> */}
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='invent_table_first_col'>
                <div> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" /></div>
                <div className='inline-initial'> <a className='prod-name' href={`/productDetail/${props.lead}/approv`} target="_blank"> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                  <p className='order_table_sku'>SKU:- {props.SKU}                 {props.showButton && <a href={`/productDetail/${props.lead}/approv`} target="_blank" class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a>}</p>
                  {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ?
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch  me-2"></i>
                      Price approval pending from Toolsvilla
                    </div> : <></>}


                  {props.showPriceMsg && props.vendor.prSts && props.vendor.prSts === "V_PENDING" ? <><div
                    className="pc_tp_new"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      // Get the new price from n_purchase_price for single products
                      const newPrice = props.vendor?.n_purchase_price;
                      const currentPrice = props.price;

                      handlePriceOfferClick({
                        productId: props.lead,
                        productName: props.productName,
                        currentPrice: currentPrice,
                        newPrice: newPrice,
                        taxClass: props.taxClass,
                        combinations: [],
                        stock: props?.quantity
                      });
                    }}
                  >
                    <i className="bi bi-info-circle me-2"></i>
                    New transfer Price Offer from Toolsvilla
                  </div></> : <></>}
                  {/* {props.showWeightMsg && props.vendor.sellerWeightChangeSts && props.vendor.sellerWeightChangeSts === "V_PENDING" ? <p className="pc_tp_wd"><i className="bi bi-info-circle me-2"></i> New weight and dimension from toolsvilla</p> : <></>} */}
                  {props.showWeightMsg && props.vendor.sellerWeightChangeSts && props.vendor.sellerWeightChangeSts === "T_PENDING" ? <p className="pc_tp_wd"><i className="bi bi-stopwatch  me-2"></i> Weight Verification Pending</p> : <></>}
                </div>
              </div>
            </td>

            <td className='invent_pro_status_inactive'>
              <div className='border-x'>
                {/* <span>Out of Stock</span> */}
                {renderStockSection()}
              </div>

            </td>
            <td>
              <div className='border-x'>

                {renderHSNSection()}


              </div>
            </td>
            <td>
              <div className='border-x'>
                <div className={props.saleDiscount ? 'prod-price sale-offer-box' : 'prod-price'}>{props.price && <i class="fa fa-inr" aria-hidden="true"></i>} {parseInt(props.price)}  {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                  <>
                    <span className='prod-card-gst'>(incl. {props.taxClass}% GST)</span>
                    {props.saleDiscount && 
                    <span className="sale-offer-text">Special Sale Transfer Price</span>}
                  </>
                )} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}</div>

                {/* <div className='prod-card-gst'>
              {!props?.recommendedPrice && props.lowestPrice && props.lowestPrice < props.price ? <span className="text-danger">Other seller's price: Rs.{props.lowestPrice}</span> : <></>}</div> */}
                 {props?.tabType == "activeProducts" && (
                  <PriceComparisonTable mProduct={props} getPriceMatchObject={props.getPriceMatchObject} />
                )}
                {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ? <p className="pc_tp_vp">Price approval pending from Toolsvilla</p> : <></>}
                {props.showPriceMsg && props.vendor.prSts && props.vendor.prSts === "V_PENDING" ? <><div
                  className="pc_tp_new"
                  style={{ cursor: 'pointer', display: 'block' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    e.preventDefault(); // Prevent default action

                    // Get the new price from n_purchase_price for single products
                    const newPrice = props.vendor?.n_purchase_price;
                    const currentPrice = props.price;

                    handlePriceOfferClick({
                      productId: props.lead,
                      productName: props.productName,
                      currentPrice: currentPrice,
                      newPrice: newPrice,
                      taxClass: props.taxClass,
                      combinations: [],
                      stock: props?.quantity,
                      vendor: props?.vendor
                    });
                  }}
                >
                  New transfer Price Offer from Toolsvilla
                </div></> : <></>}

              </div>
            </td>
            <td>
              <div className='border-x'>

                <div>

                  {!props.vendor.prSts ? <button className="invent_pro_v_t_f_btn" onClick={() => window.open(`/productDetail/${props.lead}/approv`, "_blank")}> Verify Transfer Price</button> :

                    <></>
                  }
                  <br />
                  <button className={`mt-1 ${props.lowestPrice && props.lowestPrice < props.price ? "invent_pro_modify_red" : "invent_pro_modify"}`} onClick={() => window.open(`/productDetail/${props.lead}/approv`, "_blank")}><img src={`/${props.lowestPrice && props.lowestPrice < props.price ? "edit-icon-white" : "edit-icon"}.webp`} /> Modify</button>
                </div>
              </div>

            </td>

          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
          />
        </>
      )
    }
    else {
      return (
        <>
          <tr className=' space color-row5 ord_table_row'>
            {/* <td className="td-img-cntn"></td> */}
            <td className='fs-13 invent_table_pname_cntn'>
              <div className='invent_table_first_col'>
                <div><img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" />
                </div>
                <div className='inline-initial'><a className='prod-name' href={`/productDetail/${props.lead}/approv`} target="_blank"> {props.productName} {isNew ? <Badge pill bg="success">New</Badge> : <></>}</a>
                  <p className='order_table_sku'>SKU:- {props.SKU} {props.showButton && <a href={`/productDetail/${props.lead}/approv`} target="_blank" class="detail-but"><button class="px-1 order_table_btn_details"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-3.5 h-3.5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg> Details</button></a>}</p>
                  {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ?
                    <div className="pc_tp_vp"><i className="bi bi-stopwatch  me-2"></i>
                      Price approval pending from Toolsvilla
                    </div> : <></>}
                  {props.showPriceMsg && props.vendor.prSts && props.vendor.prSts === "V_PENDING" ? <><div
                    className="pc_tp_new"
                    style={{ cursor: 'pointer', display: 'block' }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event bubbling
                      e.preventDefault(); // Prevent default action

                      // Get the new price from n_purchase_price for single products
                      const newPrice = props.vendor?.n_purchase_price;
                      const currentPrice = props.price;

                      handlePriceOfferClick({
                        productId: props.lead,
                        productName: props.productName,
                        currentPrice: currentPrice,
                        newPrice: newPrice,
                        taxClass: props.taxClass,
                        combinations: [],
                        stock: props?.quantity,
                        vendor: props?.vendor
                      });
                    }}
                  >
                    <i className="bi bi-info-circle me-2"></i>
                    New transfer Price Offer from Toolsvilla
                  </div></> : <></>}
                  {/* {props.showWeightMsg && props.vendor.sellerWeightChangeSts && props.vendor.sellerWeightChangeSts === "V_PENDING" ? <p className="pc_tp_wd"><i className="bi bi-info-circle me-2"></i> New weight and dimension from toolsvilla</p> : <></>} */}
                  {props.showWeightMsg && props.vendor.sellerWeightChangeSts && props.vendor.sellerWeightChangeSts === "T_PENDING" ? <p className="pc_tp_wd"><i className="bi bi-stopwatch  me-2"></i> Weight Verification Pending</p> : <></>}
                </div>
              </div>
            </td>

            <td className='invent_pro_status_active'>
              <div className='border-x'>
                {/* <span>In Stock</span> */}
                {
                  props.status === "INACTIVE_REQ" ?
                    <>
                      <OverlayTrigger
                        key={props.id}
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                            <p className="fs-10 f-500 payment_page_tooltip_1">  Out of stock request pending for approval</p>

                          </Tooltip>
                        }
                      >
                        <i className="bi bi-exclamation-circle ms-1 text-danger"></i>
                      </OverlayTrigger>

                    </>

                    : <></>
                }


                {/*SL-699 Seller Stock Feature Updates Start */}
                {renderStockSection()}
                {/*<label
                  style={{
                    fontSize: "11px",
                    color: editableRow !== props.lead ? "#a9a9a9" : "black", // Grey out label when input is disabled
                    marginBottom: "4px",
                    fontWeight: '400'
                  }}
                >
                  Current Stock
              </label>
              <div style={{ display: "flex",alignItems: "center" }}>
              
                <input
                    type="number"
                    value={editableRow === props.lead ? inputStockValue : props.quantity}
                    onChange={(e) => {
                      if (editableRow === props.lead) {
                        handleStockChange(e.target.value);
                      }
                    }}
                    disabled={editableRow !== props.lead} // Disable input unless it's editable
                    style={{
                      borderRadius: "3px",
                      width: "65px",
                      textAlign: "center",
                      backgroundColor: editableRow !== props.lead ? "#f0f0f0" : "white", // Greyed out background
                      color: editableRow !== props.lead ? "#a9a9a9" : "black", // Greyed out text
                      cursor: editableRow !== props.lead ? "not-allowed" : "text", // Not-allowed cursor for disabled state
                      marginBottom: "4px"
                    }}
                  />
                  
                  {editableRow === props.lead ? (
                    <img 
                      src={'/save.png'} 
                      style={{marginBottom: '5px', marginLeft: '5px', cursor: "pointer"}} 
                      onClick={handleStockSaveClick}
                    />
                  ) : (
                    <img 
                      src={'/edit-grey.png'} 
                      style={{marginBottom: '5px', marginLeft: '5px', cursor: "pointer"}} 
                      onClick={() => handleStockEditClick(props.lead,props.quantity)}
                    />
                  )}
              </div>*/}
                {/*SL-699 Seller Stock Feature Updates End */}

              </div>
            </td>
            <td>
              <div className='border-x'>
                {renderHSNSection()}
              </div>
            </td>
            {props.curURL == 'active' && <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.displayActualPrice}</span>

              <br></br>
              <span className="fs-11 text-success">TV Commission Rs. {props.displayActualPrice - props.price}<br />{props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && `(incl. ${props.taxClass}% GST)`}</span></td>}
            <td>
              <div className='border-x'>
                <div className={props.saleDiscount ? 'prod-price sale-offer-box': 'prod-price'}>{props.price && <i class="fa fa-inr" aria-hidden="true"></i>} {parseInt(props.price)}   {props.taxClass && props.taxClass !== null && props.taxClass !== undefined && props.taxClass !== 'undefined' && !isNaN(props.taxClass) && (
                  <span className='prod-card-gst'>(incl. {props.taxClass}% GST)</span>
                )} {isPriceEditingAllowed() && <i className="bi-pencil" onClick={() => handlePriceUpdate()}></i>}<br />
                 {props.saleDiscount && 
                 <span className="sale-offer-text">Special Sale Transfer Price</span>}
                </div>


                {props?.tabType == "activeProducts" && (
                  <PriceComparisonTable mProduct={props} getPriceMatchObject={props.getPriceMatchObject} />
                )}

                {props.showPriceMsg && props.vendor.prSts && props.vendor.prSts === "V_PENDING" ? <><div
                  className="pc_tp_new"
                  style={{ cursor: 'pointer', display: 'block' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    e.preventDefault(); // Prevent default action

                    // Get the new price from n_purchase_price for single products
                    const newPrice = props.vendor?.n_purchase_price;
                    const currentPrice = props.price;

                    console.log('Single product price offer clicked!', {
                      productId: props.lead,
                      productName: props.productName,
                      currentPrice: currentPrice,
                      newPrice: newPrice,
                      taxClass: props.taxClass
                    });

                    handlePriceOfferClick({
                      productId: props.lead,
                      productName: props.productName,
                      currentPrice: currentPrice,
                      newPrice: newPrice,
                      taxClass: props.taxClass,
                      combinations: [],
                      stock: props?.quantity,
                      vendor: props?.vendor
                    });
                  }}
                >
                  New transfer Price Offer from Toolsvilla
                </div></> : <></>}
                {props.vendor.prSts && props.vendor.prSts === "T_PENDING" ? <>
                  <p className="pc_tp_vp">Price approval pending from Toolsvilla</p>
                </>
                  : <></>}

              </div>
            </td>
            <td>
              <div className='border-x'>

                <div className="">

                  {!props.vendor.prSts ?
                    <button className="invent_pro_v_t_f_btn" onClick={() => window.open(`/productDetail/${props.lead}/approv`, "_blank")}> Verify Transfer Price</button> : <></>
                  }

                  <button className={`mt-1 ${props.lowestPrice && props.lowestPrice < props.price ? "invent_pro_modify_red" : "invent_pro_modify"}`} onClick={() => window.open(`/productDetail/${props.lead}/approv`, "_blank")}><img src={`/${props.lowestPrice && props.lowestPrice < props.price ? "edit-icon-white" : "edit-icon"}.webp`} /> Modify</button>
                </div>
              </div>
            </td>

          </tr>

          {/* New Price Offer Popup */}
          <NewPriceOfferPopup
            show={showPriceOfferPopup}
            onHide={() => setShowPriceOfferPopup(false)}
            productData={selectedOfferData}
            onYes={handlePriceOfferYes}
            onNo={handlePriceOfferNo}
            onNewPriceSubmit={handleNewPriceSubmit}
          />
        </>
      )
    }
  }

}

export default ProductCard;